import { Component, OnInit } from '@angular/core';
import {TourApiService} from '../services/tour-api.service';
import {ImageSize} from '../model/image';
import {ContactInfo} from '../model/contact-info';
import {TourService} from '../services/tour.service';
import {Person} from '../model/person';
import {EnumAware} from '../decorators/enum-aware.decorator';
import {TrackingService} from '../services/tracking.service';

@Component({
  selector: 'gt-contacts',
  templateUrl: './contacts.component.html',
  styleUrls: ['./contacts.component.css']
})
@EnumAware
export class ContactsComponent implements OnInit {
  ImageSize = ImageSize;
  info: ContactInfo;
  activePerson: Person;
  constructor(public apiService: TourApiService, private tourService: TourService, private trackingService: TrackingService) { }

  ngOnInit() {
    this.info = this.tourService.tour.contactInfo;
    this.activePerson = this.info.sections[0].items[0];
    this.tourService.setDocumentTitleWithTour(this.tourService.tourFeatureTitle('contacts'));
    this.trackingService.trackAction(TrackingService.kActionContact, this.activePerson.displayName, 0);
  }

  showPerson(person: Person) {
    this.activePerson = person;
    const el = document.querySelector('#contact-detail');
    if (el != null) {
      el.scrollIntoView();
    }
    this.trackingService.trackAction(TrackingService.kActionContact, this.activePerson.displayName, 0);
  }

  stripAllButDigits(stringWithNumbers: string) {
    return stringWithNumbers.replace(/\D/g, '');
  }
}



// WEBPACK FOOTER //
// ./src/app/components/contacts.component.ts